<template>
  <div class="videoTagList common-max-width">
    <div class="videoTagList-header">
      <div class="videoTagList-header-title">{{title}}</div>
      <button
        class="videoTagList-header-btn"
        @click="$emit('close')">
        <van-icon
          name="arrow-up"
          color="#fff"
          size="20px"/>
      </button>
    </div>
    <ul
      ref="tagList"
      class="videoTagList-list">
      <video-item
        v-for="video of data"
        :key="video.id"
        class="videoTagList-list-item"
        :video-id="video.id"
        :img="video.coverbase64"
        :title="video.title"
        :tags="video.labls"
        :views="video.pageviews"
        v-on="$listeners"/>
    </ul>
  </div>
</template>

<script>
import VideoItem from '@/components/VideoItem'
export default {
  name: 'videoTagList',
  components: {
    VideoItem
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      required: true
    }
  },
  watch: {
    title () {
      this.$refs.tagList.scrollTop = 0
    }
  }
}
</script>

<style scoped>
.videoTagList {
  position: fixed;
  top: 50%;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 15px;
  background-color: #000;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.videoTagList-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 5px;
  border-bottom: 1px solid #313131;
}

.videoTagList-header-title {
  font-size: 14px;
  line-height: 30px;
  color: #fff;
  text-align: left;
}

.videoTagList-header-btn {
  cursor: pointer;
  background-color: transparent;
  border: none;
}

.videoTagList-list {
  width: 100%;
  height: 95%;
  overflow-y: auto;
  list-style: none;
}

.videoTagList-list > .videoTagList-list-item:last-child::after {
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoTagList.vue